import { SMILE9_API_ENDPOINT } from './../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateWebInstructionsClickLogRequest } from './tutorial-if';

@Injectable()
export class TutorialHttpLogService {

  constructor(
    private http: HttpClient,
  ) { }

  /**
   * クリックログをDBへ出力
   */
  public createWebInstructionsClickLog() {
    const httpBody: CreateWebInstructionsClickLogRequest = {
        url: location.href,
    };
    return this.http.request(
        'post',
        `${SMILE9_API_ENDPOINT}api/WebInstructionsLog/ClickLog`,
        { body: httpBody }
    );
  }
}
